// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TGuJ","input":"styles_input__Fgy99"};